export enum LicenseType {
  Active = 1,
}
